export default {
  appid: "wx4753e8cdf3749bbf",
  Url: "https://carpark.grguser.com/#/",
  img: '/static/logoImg/pingyun.png',
  car: "A",
  payChannel: 1
};



// WEBPACK FOOTER //
// ./src/config/modules/pro.by.js